import React from 'react'

import { tabBar, tabBarItem } from '@ui-kit/components/TabBar/styles'

import type { Props } from './types'

const TabBar = (props: Props) => {
  const [tabUnderlineWidth, setTabUnderlineWidth] = React.useState(0)
  const [tabUnderlineLeft, setTabUnderlineLeft] = React.useState(0)
  const tabsRef = React.useRef<(HTMLButtonElement | null)[]>([])
  const activeTabIndex = props.tabs.findIndex((tab) => tab.value === props.currentTabValue)
  const { container, underline } = tabBar()
  React.useEffect(() => {
    function setTabPosition() {
      const currentTab = tabsRef.current[activeTabIndex]
      setTabUnderlineLeft(currentTab?.offsetLeft ?? 0)
      setTabUnderlineWidth(currentTab?.clientWidth ?? 0)
    }

    setTabPosition()
    window.addEventListener('resize', setTabPosition)

    return () => window.removeEventListener('resize', setTabPosition)
  }, [activeTabIndex])
  return (
    <div className={container()}>
      {props.tabs.map((tab, index) => {
        const isSelected = tab.value === props.currentTabValue
        const { button, text } = tabBarItem({ isSelected })
        return (
          <button
            className={button()}
            ref={(el) => (tabsRef.current[index] = el)}
            key={tab.value}
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault()
              props.onTabChange(tab.value)
            }}
          >
            <span className={text()}>{tab.label}</span>
          </button>
        )
      })}
      <span className={underline()} style={{ left: tabUnderlineLeft, width: tabUnderlineWidth }} />
    </div>
  )
}

export default TabBar
